<template>
  <div class="reportIndex">
    <component
      v-for="(item, index) in All"
      :key="index"
      :is="item.name"
    ></component>

    <div>
      <!-- <component
        v-for="item in componentList"
        :key="item.templateId"
        :is="item.elementName"
        :moduleIsShow="item.moduleIsShow"
        :templateIsShow="item.templateIsShow"
        :templateId="item.templateId"
        :title="item.moduleNameShow"
        :moduleAnnotation="item.moduleAnnotation"
      ></component> -->
    </div>
    <div v-if="empty">
      <!-- <van-empty
        class="custom-image"
        image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
        description="当前产品没有配置模块信息"
      /> -->
      <van-skeleton title :row="10" />
    </div>
    <!-- <component :is="yc"></component> -->
  </div>
</template>
<script>
import { Components } from "./components/component";
import { getTemplate } from "@/api/reportQuery";
import { Toast } from "vant";
import { mapMutations } from "vuex";
// Toast.setDefaultOptions({ duration: 0 });
export default {
  name: "reportIndex",
  components: Components,
  data() {
    return {
      All: [
        {
          name: "singleNucleotide",
        },
        {
          name: "methylaTion",
        },
        {
          name: "cnvResult",
        },

        {
          name: "rnvResult",
        },
        {
          name: "testing",
        },
        // {
        //   name: "ImportantGene",
        // },
        // {
        //   name: "ZlAssess",
        // },
        // {
        //   name: "YcygVariation",
        // },
        // {
        //   name: "ByClass",
        // },
        // {
        //   name:'Reference'
        // }
        // {
        //   name: "Appendix",
        // },
        // {
        //   name: "Dpart",
        // },
        // {
        //   name: "MutationList",
        // },
        // {
        //   name: "Ramucirumab",
        // },
        // {
        //   name: "Reference",
        // },
        // {
        //   name: "Typing",
        // },
        // {
        //   name: "Typingtips",
        // },
      ],
      componentList: [],
      labOriginalSampleNo: "W201100a5T",
      productId: "fwa-p825",
      // labOriginalSampleNo: "",
      // productId: "",
      title: "",
      empty: false,
    };
  },
  beforeCreate() {},
  created() {},
  mounted() {
    console.log(this.title);
    let params = {
      labOriginalSampleNo: this.labOriginalSampleNo,
      productId: this.productId,
    };
    this.setPublic(params);
    // sessionStorage.setItem('params',params)
    // let p = {
    //   productName2: "肺癌180基因检测（血液版）（含白细胞）",
    //   organization: "浙江省肿瘤医院",
    // };
    // this.Template(p);
  },
  methods: {
    ...mapMutations("embry", ["setPublic"]),
    // 获取模版接口
    async Template(param) {
      try {
        let { data } = await getTemplate({
          Product: param.productName2,
          organization: param.organization,
          // Product: '肺癌180基因检测（血液版）（含白细胞）',
          // organization: '浙江省肿瘤医院',
        });
        this.componentList = data;
        if (this.componentList == "") {
          this.empty = true;
        }
      } catch (error) {}
    },
  },
  /**获取动态模版 */
  //   beforeRouteEnter: (to, from, next) => {
  //     window.NativeCallJS = (res) => {
  //       var par = JSON.parse(res);
  //       next((vm) => {
  //         let params = {
  //           labOriginalSampleNo: par.labOriginalSampleNo,
  //           productId: par.productId,
  //         };
  //         vm.setPublic(params);
  //         vm.Template(par);
  //       });
  //     };
  //   },
};
</script>
<style lang="less" scoped>
.reportIndex {
  padding: 0 16px 30px;
  font-family: @family;
}
</style>
